export default __webpack_public_path__ + "static/media/pcp-guide-chart-4.2117d5e7.svg";